/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustRecordListResVo } from './AdminStockAdjustRecordListResVo';
import {
    AdminStockAdjustRecordListResVoFromJSON,
    AdminStockAdjustRecordListResVoFromJSONTyped,
    AdminStockAdjustRecordListResVoToJSON,
    AdminStockAdjustRecordListResVoToJSONTyped,
} from './AdminStockAdjustRecordListResVo';

/**
 * 
 * @export
 * @interface PageDataAdminStockAdjustRecordListResVo
 */
export interface PageDataAdminStockAdjustRecordListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataAdminStockAdjustRecordListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataAdminStockAdjustRecordListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataAdminStockAdjustRecordListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<AdminStockAdjustRecordListResVo>}
     * @memberof PageDataAdminStockAdjustRecordListResVo
     */
    records?: Array<AdminStockAdjustRecordListResVo>;
}

/**
 * Check if a given object implements the PageDataAdminStockAdjustRecordListResVo interface.
 */
export function instanceOfPageDataAdminStockAdjustRecordListResVo(value: object): value is PageDataAdminStockAdjustRecordListResVo {
    return true;
}

export function PageDataAdminStockAdjustRecordListResVoFromJSON(json: any): PageDataAdminStockAdjustRecordListResVo {
    return PageDataAdminStockAdjustRecordListResVoFromJSONTyped(json, false);
}

export function PageDataAdminStockAdjustRecordListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataAdminStockAdjustRecordListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminStockAdjustRecordListResVoFromJSON)),
    };
}

export function PageDataAdminStockAdjustRecordListResVoToJSON(json: any): PageDataAdminStockAdjustRecordListResVo {
    return PageDataAdminStockAdjustRecordListResVoToJSONTyped(json, false);
}

export function PageDataAdminStockAdjustRecordListResVoToJSONTyped(value?: PageDataAdminStockAdjustRecordListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminStockAdjustRecordListResVoToJSON)),
    };
}

